import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registrazione Service Worker per PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✅ PWA: Service Worker registered successfully:', registration.scope);
        
        // Controlla aggiornamenti ogni ora
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // 1 ora
        
        // Gestisci aggiornamenti del service worker
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Nuovo service worker disponibile
                console.log('🔄 PWA: Nuova versione disponibile');
                
                // Opzionale: mostra notifica all'utente
                if (window.confirm('È disponibile una nuova versione di FantaClasse. Vuoi ricaricare?')) {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                  window.location.reload();
                }
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('❌ PWA: Service Worker registration failed:', error);
      });
    
    // Ricarica quando un nuovo service worker prende il controllo
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });
  });
}

// Gestione eventi install prompt (A2HS - Add to Home Screen)
let deferredPrompt;

window.addEventListener('beforeinstallprompt', (e) => {
  console.log('💾 PWA: Install prompt available');
  // Previene il prompt automatico di Chrome
  e.preventDefault();
  // Salva l'evento per usarlo dopo
  deferredPrompt = e;
  
  // Opzionale: mostra un pulsante custom per installare l'app
  // Puoi creare un componente React che usa questa variabile
  window.showInstallPromotion = true;
});

// Traccia quando l'app viene installata
window.addEventListener('appinstalled', () => {
  console.log('🎉 PWA: App installed successfully');
  deferredPrompt = null;
});

// Esponi funzione globale per trigger manuale dell'installazione
window.promptPWAInstall = async () => {
  if (!deferredPrompt) {
    console.log('PWA: Install prompt not available');
    return false;
  }
  
  // Mostra il prompt
  deferredPrompt.prompt();
  
  // Aspetta la scelta dell'utente
  const { outcome } = await deferredPrompt.userChoice;
  console.log(`PWA: User choice: ${outcome}`);
  
  // Pulisci il prompt
  deferredPrompt = null;
  
  return outcome === 'accepted';
};
